import type AnnouncementRecipientModel from 'garaje/models/announcement-recipient';
import type { SinglePayload } from 'jsonapi/response';

import ApplicationSerializer from './application';

export default class AnnouncementRecipientSerializer extends ApplicationSerializer {
  serialize(...args: Parameters<ApplicationSerializer['serialize']>): SinglePayload<AnnouncementRecipientModel> {
    const payload = <SinglePayload<AnnouncementRecipientModel>>super.serialize(...args);
    const [record, _] = args;

    // Only include response and lastResponseAt attributes for PATCH operations (update)
    // Check if the snapshot has an ID, indicating it's an existing record being updated.
    if (record.id) {
      const attributes = payload?.data?.attributes || {};
      const filteredAttributes: Record<string, unknown> = {};

      if ('response' in attributes) {
        filteredAttributes['response'] = attributes['response'];
      }

      if ('last-response-at' in attributes) {
        filteredAttributes['last-response-at'] = attributes['last-response-at'];
      }

      payload.data.attributes = filteredAttributes;

      // Last updated by field is determined by the user's jwt
      if ('last-updated-by' in payload.data.relationships) {
        delete payload.data.relationships['last-updated-by'];
      }
    }

    return payload;
  }
}
